<template>
    <div>
        <v-data-table v-model="selectedItems" :headers="headers" :items="items" :items-per-page="10"
            :options.sync="options" :server-items-length="totalItems" item-key="id" show-select :loading="isLoading"
            :loading-text="$t('loadingPleaseWait')" :no-data-text="$t('noData')" :footer-props="footerProps"
            :header-props="headerProps">
            <template v-slot:item.action="{ item }">
                <div style="width: 50px;">
                    <v-icon small @click="showEditDialog(item.valueId)"> edit </v-icon>
                    <v-icon small @click="showDeleteSnack(item.valueId)">
                        close
                    </v-icon>
                </div>
            </template>
        </v-data-table>
        <v-snackbar color="main--black" dark v-model="snackOpen" top v-if="snackDelete">
            <span class="caption pr-4">{{ snackText }}</span>
            <span v-if="snackDelete" class="caption pr-4">{{ $t('delete') }} ?</span>
            <div>
                <v-btn text class="text--main-yellow" @click="deleteAttributeValue">{{ $t('yes') }}</v-btn>
                <v-btn text icon @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
        <v-snackbar v-else v-model="snackOpen" centered>
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn text icon v-bind="attrs" @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <enum-attribute-value-fullscreen-dialog :is-open="openEnumAttributeValueDialog" :dialog-type="'edit'"
            :attributeValueID="updatingId" @validated="updateAttributeValue"
            @close="openEnumAttributeValueDialog = false"></enum-attribute-value-fullscreen-dialog>
    </div>
</template>

<script>
import { AttributesService } from "../../../services";
import { MixinAppSnack, MixinTableLoadState } from '../../../mixins'
import { EnumAttributeValueDialog, EnumAttributeValueFullscreenDialog } from '../../modals'

export default {
    name: "AttributesTable",
    components: { EnumAttributeValueDialog, EnumAttributeValueFullscreenDialog },
    mixins: [MixinAppSnack, MixinTableLoadState],
    props: ['filters'],
    data() {
        return {
            headers: [],
            items: [],
            options: {},
            totalItems: null,
            updatingId: null,
            footerProps: {
                'items-per-page-text': this.$t('rowsPerPage'),
                'items-per-page-all-text': this.$t('all'),
                'page-text': /*this.$t('from')*/ '',
            },
            headerProps: {
                sortByText: this.$t('sortBy'),
            },
            openEnumAttributeValueDialog: false,
            editSnack: false,
        }
    },
    computed: {
        selectedItems: {
            get() {
                return this.$store.getters.selectedAttributesValues;
            },
            set(newVal) {
                this.$store.commit('setSelectedAttributesValues', newVal);
            }
        },
        updateTableData() {
            return this.$store.getters.updateAttributesTable;
        }
    },
    methods: {
        setItems() {
            if (!this.startTableLoading()) return false;

            const params = {
                ...this.options,
                pageType: this.pageType,
                filters: this.filters
            };

            AttributesService.setAuth(this.$store.getters.token);
            AttributesService.getAttributesValues(params)
                .then(res => {
                    this.items = res.data.data;
                    this.totalItems = res.data.total;
                })
                .catch(err => {
                    this.emitTableLoadError(err);
                })
                .finally(() => {
                    this.stopTableLoading();
                });
        },
        setTable() {
            AttributesService.setAuth(this.$store.getters.token);
            AttributesService.getTableData()
                .then(res => {
                    this.headers = res.data.headers;
                })
                .catch(err => {
                    this.emitTableLoadError(err);
                })
        },
        showEditDialog(id) {
            this.updatingId = id;
            this.openEnumAttributeValueDialog = true;
        },
        showDeleteSnack(id) {
            this.updatingId = id;
            this.resetSnack();
            this.setDeleteSnack();
            this.setDeleteSnackState();
            this.openSnack();
        },
        updateAttributeValue(data) {
            this.$emit('overlay-view', true);
            this.openEnumAttributeValueDialog = false;
            AttributesService.setAuth(this.$store.getters.token);
            AttributesService.updateAttributeValue(data)
                .then((res) => {
                    this.$store.commit('setUpdateAttributesFilters', true);
                    this.snackText = res.data.error ? this.$t('editAttributeValueError') : this.$t('editAttributeValueSuccess');
                    this.openSnack();
                    this.setItems();
                })
                .catch(err => {
                    console.log(err);
                    this.snackText = this.$t('editAttributeValueError');
                    this.openSnack();
                })
                .finally(() => {
                    this.$emit('overlay-view', false);
                });
        },
        deleteAttributeValue() {
            this.resetSnack();
            this.$emit('overlay-view', true);
            AttributesService.setAuth(this.$store.getters.token);
            AttributesService.deleteAttributeValue(this.updatingId)
                .then(() => {
                    this.setSuccessSnack();
                    this.setSnackText(this.$t('successfulDeleted'));
                    this.openSnack();
                    this.setItems();
                })
                .catch(err => {
                    console.log(err);
                    this.setDeleteSnack();
                    this.setSnackText(this.$t('dataErrorUpdated'));
                    this.openSnack();
                }).finally(() => {
                    this.$emit('overlay-view', false);
                });
            this.updatingId = null;
        },
    },
    created() {
        this.setTable();
    },
    watch: {
        options: {
            handler() {
                this.setItems();
            },
            deep: true
        },
        filters: {
            handler() {
                this.setItems();
            },
            deep: true
        },
        updateTableData(value) {
            if (value) {
                this.setItems();
                this.$store.commit('setUpdateAttributesTable', false);
            }
        },
        editSnack(value) {
            if (value) {
                this.editSnack = false;
            }
        }
    }
}
</script>

<style scoped></style>
